import { Directive, HostListener, ElementRef, Input, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { AsYouTypeFormatter, PhoneNumberUtil } from 'google-libphonenumber';

@Directive({
    selector: '[appPhoneFormatter]'
})
export class PhoneFormatterDirective {
    @Input('appPhoneFormatter') countryCode: string = 'IN'; // default India

    // private phoneUtil = PhoneNumberUtil.getInstance();

    constructor(private el: ElementRef) { }
    
    @HostListener('input', ['$event.target.value'])
    onInputChange(value: string) {
        const input = value.replace(/\D/g, ''); // strip non-digits
        const formatter = new AsYouTypeFormatter(this.countryCode);

        let formatted = '';
        for (let i = 0; i < input.length; i++) {
            formatted = formatter.inputDigit(input.charAt(i));
        }

        this.el.nativeElement.value = formatted;
    }
}